import {
  LOGIN_PROFILE_CREATED_RESET,
  REQUEST_DASHBOARD_DATA,
  REQUEST_DASHBOARD_DATA_FAILURE,
  REQUEST_DASHBOARD_DATA_SUCCESS,
  REQUEST_DASHBOARD_LEADS,
  REQUEST_DASHBOARD_LEADS_FAILURE,
  REQUEST_DASHBOARD_LEADS_SUCCESS,
  REQUEST_GROUPLIST_DATA,
  REQUEST_GROUPLIST_DATA_FAILURE,
  REQUEST_GROUPLIST_DATA_SUCCESS,
  REQUEST_GROUPWISE_DATA,
  REQUEST_GROUPWISE_DATA_FAILURE,
  REQUEST_GROUPWISE_DATA_SUCCESS,
} from "../../utils/constants";

// ------------------------------------
// Action handler methods
// ------------------------------------
export const handleGroupListDataRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
  };
};

export const handleGroupListDataRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      groupList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleGroupListDataRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;

  let token = localStorage.getItem("access_token");
  if (token === null) {
    return {
      ...state,
      isLoading: false,
      redirect: true,
      data: null,
    };
  }
  if (response.status === 401 && response.data.code === "user_inactive") {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "inactive",
    };
  }
  if (
    token &&
    response?.status === 403 &&
    response?.data?.detail ===
      "only active subscribers can perform this operation"
  ) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "paused",
    };
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
    groupList: null,
  };
};

export const handleDashboardDataRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
    error: null,
  };
};

export const handleDashboardDataRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: data.data,
      error: null,
    };
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
    error: "Unable to load dashboard data.",
  };
};

export const handleDashboardDataRequestFailure = (state, action) => {
  const response = action?.payload?.response;
  const error =
    response?.data?.detail ||
    response?.data?.message ||
    action?.payload?.message ||
    "Unable to load dashboard data.";
  let token = localStorage.getItem("access_token");
  if (token === null) {
    return {
      ...state,
      isLoading: false,
      redirect: true,
      data: null,
      error: null,
    };
  }
  if (response?.status === 401 && response?.data?.code === "user_inactive") {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "inactive",
      error: null,
    };
  }

  if (
    token &&
    response?.status === 403 &&
    response?.data?.detail ===
      "only active subscribers can perform this operation"
  ) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "paused",
      error: null,
    };
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
    data: null,
    error,
  };
};

export const handleDashboardLeadsRequest = (state, action) => ({
  ...state,
  recentLeadsLoading: true,
  recentLeadsError: null,
});

export const handleDashboardLeadsRequestSuccess = (state, action) => {
  const response = action?.payload?.data;

  if (response?.status === 200) {
    return {
      ...state,
      recentLeads: response.data,
      recentLeadsLoading: false,
      recentLeadsError: null,
    };
  }

  return {
    ...state,
    recentLeadsLoading: false,
    recentLeadsError: "Unable to load recent leads.",
  };
};

export const handleDashboardLeadsRequestFailure = (state, action) => {
  const response = action?.payload?.response;
  const error =
    response?.data?.detail ||
    response?.data?.message ||
    action?.payload?.message ||
    "Unable to load recent leads.";
  const nextState = {
    ...state,
    recentLeads: null,
    recentLeadsLoading: false,
    recentLeadsError: error,
  };
  const token = localStorage.getItem("access_token");

  if (token === null) {
    return {
      ...nextState,
      redirect: true,
      recentLeadsError: null,
    };
  }

  if (response?.status === 401 && response?.data?.code === "user_inactive") {
    return {
      ...nextState,
      subscriptionStatus: "inactive",
      recentLeadsError: null,
    };
  }

  if (
    response?.status === 403 &&
    response?.data?.detail === "only active subscribers can perform this operation"
  ) {
    return {
      ...nextState,
      subscriptionStatus: "paused",
      recentLeadsError: null,
    };
  }

  return nextState;
};

export const handleGroupwiseDataRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
  };
};

export const handleGroupwiseDataRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleGroupwiseDataRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  let token = localStorage.getItem("access_token");
  if (token === null) {
    return {
      ...state,
      isLoading: false,
      redirect: true,
      data: null,
    };
  }
  if (response.status === 401 && response.data.code === "user_inactive") {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "inactive",
    };
  }
  if (
    token &&
    response?.status === 403 &&
    response?.data?.detail ===
      "only active subscribers can perform this operation"
  ) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      data: null,
      subscriptionStatus: "paused",
    };
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
    data: null,
  };
};

export const handleLogoutRequest = (state, action) => {
  return {
    ...state,
    ...initialState,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [REQUEST_DASHBOARD_DATA]: handleDashboardDataRequest,
  [REQUEST_DASHBOARD_DATA_SUCCESS]: handleDashboardDataRequestSuccess,
  [REQUEST_DASHBOARD_DATA_FAILURE]: handleDashboardDataRequestFailure,
  [REQUEST_DASHBOARD_LEADS]: handleDashboardLeadsRequest,
  [REQUEST_DASHBOARD_LEADS_SUCCESS]: handleDashboardLeadsRequestSuccess,
  [REQUEST_DASHBOARD_LEADS_FAILURE]: handleDashboardLeadsRequestFailure,
  [REQUEST_GROUPWISE_DATA]: handleGroupwiseDataRequest,
  [REQUEST_GROUPWISE_DATA_SUCCESS]: handleGroupwiseDataRequestSuccess,
  [REQUEST_GROUPWISE_DATA_FAILURE]: handleGroupwiseDataRequestFailure,
  [REQUEST_GROUPLIST_DATA]: handleGroupListDataRequest,
  [REQUEST_GROUPLIST_DATA_SUCCESS]: handleGroupListDataRequestSuccess,
  [REQUEST_GROUPLIST_DATA_FAILURE]: handleGroupListDataRequestFailure,
  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
};

// default initial state
const initialState = {
  isLoading: false,
  redirect: false,
  groupList: undefined,
  data: undefined,
  error: null,
  recentLeads: undefined,
  recentLeadsLoading: false,
  recentLeadsError: null,
};

export default function dashboardReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
